import React, { useState } from 'react'
import { IconButton, Typography, Box, Card } from '@mui/material'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import moment from 'moment'

export const CalendarComponent = ({year, setYear}) => {
    

    const handlePreviousYear = () => {
        setYear(moment().year(year).subtract(1, 'year').year())
    }

    const handleNextYear = () => {
        setYear(moment().year(year).add(1, 'year').year())
    }

    return (
        <Box display="flex" alignItems="center">
            <IconButton onClick={handlePreviousYear} disabled={year == 2022}>
                <KeyboardArrowLeftIcon />
            </IconButton>
            <Card>
                <Typography variant="h6" sx={{ mx: 2 }}>
                    {year}
                </Typography>
            </Card>
            <IconButton onClick={handleNextYear} disabled={year == 2024}>
                <KeyboardArrowRightIcon />
            </IconButton>
        </Box>
    )
}
